import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getRecurringTaskPaginated,
  IRecurringTaskPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { RecurringTaskModalModes } from "./enums";
import { IRecurringTaskModalData } from "./types";

const initialState = {
  recurringTaskData: null as Nullable<IRecurringTaskPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: RecurringTaskModalModes.VIEW,
    open: false,
    loading: false,
  } as IRecurringTaskModalData,
};

export const fetchRecurringTasks = createAsyncThunk(
  "tasks/fetchRecurringTasks",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getRecurringTaskPaginated(filters);
    return response;
  }
);

const recurringTaskSlice = createSlice({
  name: "recurringTask",
  initialState,
  reducers: {
    setRecurringTaskModalData: (
      state,
      action: PayloadAction<IRecurringTaskModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeRecurringTaskModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setRecurringTaskModalLoading: (state, action: PayloadAction<boolean>) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRecurringTasks.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        recurringTaskData: action.payload
          ?.edges as IRecurringTaskPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchRecurringTasks.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setRecurringTaskModalData,
  closeRecurringTaskModal,
  setRecurringTaskModalLoading,
} = recurringTaskSlice.actions;

export default recurringTaskSlice.reducer;
